import { useEffect, useState } from "react";
import { beginn, mitRahmen, niedrigste, zuletzt, type Bildratenstand } from "./lib/bildrate.ts";

/**
 * Der zuschaltbare Bildraten-Zähler aus `PROTOTYP-PLAN.md` P5.
 *
 * **Zuschaltbar über `?messen=1` in der Adresse** und sonst gar nicht vorhanden. Der
 * Grund steht in P5: gemessen werden muss auf **Annas Gerät**, und dort gibt es kein
 * Kabel und keine Entwicklerwerkzeuge. Ein Schalter in der Oberfläche wäre für ihre
 * Kundschaft ein Rätsel; eine Adresse mit Anhang tippt man einmal ein.
 *
 * Der Zähler selbst rechnet in `src/lib/bildrate.ts`, ohne React und ohne Browser — nur
 * so lässt sich prüfen, dass er beim Stocken auch stockende Zahlen meldet.
 *
 * ⚠️ Er ist **selbst** ein Zustandswechsel je Sekunde. Deshalb steht er in einer eigenen
 * Komponente und nicht in der Reihe: so rendert einmal je Sekunde diese Anzeige neu und
 * nicht 60 Figuren (ARCHITEKTUR.md 3.1).
 */

/** Der Schwellwert aus P5 — **gesetzt, nicht gemessen und nicht belegt.** Er steht hier,
 *  damit die Anzeige selbst sagt, ob sie darunter liegt, statt es später auszurechnen. */
export const SCHWELLE_BILDER_PRO_SEKUNDE = 50;

export function messenGewuenscht(suche: string): boolean {
  return new URLSearchParams(suche).get("messen") === "1";
}

export default function Bildrate() {
  const [stand, setStand] = useState<Bildratenstand>(() => beginn(performance.now()));

  useEffect(() => {
    let laeuft = true;
    let angefordert = requestAnimationFrame(function rahmen(zeit) {
      if (!laeuft) return;
      setStand((bisher) => mitRahmen(bisher, zeit));
      angefordert = requestAnimationFrame(rahmen);
    });
    return () => {
      laeuft = false;
      cancelAnimationFrame(angefordert);
    };
  }, []);

  const tief = niedrigste(stand);
  const letzte = zuletzt(stand);
  const unterSchwelle = tief !== null && tief < SCHWELLE_BILDER_PRO_SEKUNDE;

  return (
    <p
      aria-live="off"
      // Oben rechts und nicht unten: unten liegt seit dem 24.09.2026 die feste
      // Werkzeugleiste, und ein Messgerät, das den „Fertig"-Knopf verdeckt, misst sich
      // selbst in die Quere.
      className={`pointer-events-none fixed top-2 right-2 z-20 rounded-lg px-3 py-2 font-mono text-xs ${
        unterSchwelle ? "bg-red-900 text-white" : "bg-neutral-900 text-neutral-100"
      }`}
    >
      {tief === null
        ? "Bildrate wird gemessen …"
        : `niedrigste ${String(tief)}/s · jetzt ${String(letzte ?? tief)}/s · Ziel ${String(
            SCHWELLE_BILDER_PRO_SEKUNDE,
          )}/s`}
    </p>
  );
}
